import React, { useState, useEffect } from "react";
import Select from "react-select";
import apiClient from "../api/apiClient";

const FileDownloadAndPreviewComponent = () => {
  const [wizardName, setWizardName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);
  const [txtContent, setTxtContent] = useState("");
  const [generatedBlob, setGeneratedBlob] = useState(null);
  const [generatedFilename, setGeneratedFilename] = useState("");
  const [sftpConnected, setSftpConnected] = useState(false);
  const [ftpPath, setFtpPath] = useState("/");
  const [ftpItems, setFtpItems] = useState([]);
  const [ftpVisible, setFtpVisible] = useState(false);
  const DEFAULT_SFTP_PATH = "/LADERO PARAGUAYO/3211/315/03211_315_1";

  // Obtener lista de procesos de pago
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await apiClient.get("/banks/payments");

        if (!Array.isArray(response.data)) {
          throw new Error("Los datos recibidos no son un array");
        }

        const formattedItems = response.data.map((item) => ({
          value: item.WizardName,
          label: item.WizardName,
        }));

        setProjects(formattedItems);
      } catch (err) {
        console.error("Error obteniendo los procesos de pago", err);
        setError("Error al obtener los procesos de pago.");
      }
    };

    fetchItems();
  }, []);

  // Función para generar nombre de archivo
  const generateFileName = (wizard) => {
    const now = new Date();
    const fechaActual = now.toISOString().split("T")[0].replace(/-/g, ""); // AAAAMMDD
    const horaActual = now.toTimeString().split(" ")[0].replace(/:/g, ""); // HHMMSS
    const sanitizedWizardName = wizard.replace(/[<>:"/\\|?*]/g, "_");
    return `003211_${fechaActual}_${horaActual}_${sanitizedWizardName}.TXT`;
  };

  const handleGenerateAndPreview = async () => {
    if (!wizardName) {
      setError("Debe seleccionar un proceso de pago.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.post(
        "/generar-txt/atlas",
        { wizard_name: wizardName.value },
        { responseType: "blob" }
      );

      const fileBlob = new Blob([response.data], { type: "text/plain" });
      const textContent = await fileBlob.text(); // Convertir blob a texto
      setTxtContent(textContent);
      setGeneratedBlob(fileBlob);
      setGeneratedFilename(generateFileName(wizardName.value));
    } catch (err) {
      console.error("Error generando el archivo:", err);
      setError("Error al generar el archivo. Verifica el servidor.");
    }

    setLoading(false);
  };

  const handleDownload = () => {
    if (!generatedBlob || !generatedFilename) return;
    const url = window.URL.createObjectURL(generatedBlob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", generatedFilename);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const handleConnectSFTP = () => {
    loadSftpDirectory(DEFAULT_SFTP_PATH); // sin parámetros, el back usará la ruta por defecto
  };
  
  const loadSftpDirectory = async (path) => {
    setLoading(true);
    setError(null);
  
    try {
      const response = await apiClient.get("/sftp/list", {
        params: { path: DEFAULT_SFTP_PATH }, // Si no hay path, no envía nada
      });
  
      setFtpItems(response.data.items);
      setFtpPath(response.data.currentPath);  // Para mostrar la ruta actual
      setFtpVisible(true);
      setSftpConnected(true);   // ✅ ¡Aquí marcas que ya está conectado!
    } catch (err) {
      console.error("Error conectando al SFTP:", err);
      setError("No se pudo conectar al SFTP.");
      setSftpConnected(false);
    }
  
    setLoading(false);
  };
  
  const handleSendToSFTP = async () => {
    if (!generatedBlob || !generatedFilename) return;
  
    const formData = new FormData();
    formData.append("file", generatedBlob, generatedFilename);
    formData.append("filename", generatedFilename);
  
    setLoading(true);
    setError(null);
  
    try {
      const response = await apiClient.post("/sftp/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert(response.data.message || "Archivo enviado exitosamente por SFTP.");

      // ✅ Limpiar los datos luego del envío exitoso
      setWizardName(null);
      setGeneratedBlob(null);
      setGeneratedFilename("");
      setTxtContent("");
      setError(null);

    } catch (err) {
      console.error("Error enviando archivo por SFTP:", err);
      setError("Error al enviar el archivo por SFTP.");
    }
  
    setLoading(false);
  };
  

  return (
    <div className="container mt-4">
      <h2>Pago Proveedores - Banco Atlas</h2>

      <div className="mb-3">
        <label className="form-label">Nombre del Proceso de Pago:</label>
        <Select
          options={projects}
          value={wizardName}
          onChange={setWizardName}
          placeholder="Seleccione un proceso..."
          isSearchable={true}
        />
      </div>

      {error && <p className="text-danger">{error}</p>}

      <div className="d-flex gap-3 mb-4">
        <button className="btn btn-secondary" onClick={handleGenerateAndPreview} disabled={loading}>
          {loading ? "Generando..." : "Generar y Mostrar"}
        </button>

        <button className="btn btn-primary" onClick={handleSendToSFTP} disabled={!generatedBlob}>
          Subir al Banco
        </button>
        <button className="btn btn-primary" onClick={handleDownload} disabled={!generatedBlob}>
          Descargar Archivo
        </button>
      </div>
      
      {ftpVisible && (
        <div className="mt-4">
          <h5>Explorando FTP: {ftpPath}</h5>
          {ftpPath !== "/" && (
            <button
              className="btn btn-sm btn-secondary mb-2"
              onClick={() => {
                const parentPath = ftpPath.substring(0, ftpPath.lastIndexOf("/")) || "/";
                loadSftpDirectory(parentPath);
              }}
            >
              ⬅ Volver atrás
            </button>
          )}
          <ul className="list-group">
            {ftpItems.map((item, idx) => (
              <li
                key={idx}
                className="list-group-item d-flex justify-content-between"
                style={{ cursor: item.type === "dir" ? "pointer" : "default" }}
                onClick={() => {
                  if (item.type === "dir") {
                    const newPath = ftpPath === "/" ? `/${item.name}` : `${ftpPath}/${item.name}`;
                    loadSftpDirectory(newPath);
                  }
                }}
              >
                <span>
                  {item.type === "dir" ? "📁" : "📄"} {item.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {txtContent && (
        <div>
          <h5>Contenido generado:</h5>
          <pre
            style={{
              backgroundColor: "#f8f9fa",
              padding: "15px",
              border: "1px solid #dee2e6",
              whiteSpace: "pre-wrap",
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {txtContent}
          </pre>
        </div>
      )}

      

    </div>
  );
};

export default FileDownloadAndPreviewComponent;
